import { Component, ErrorInfo, ReactNode, version as reactVersion } from 'react'

import { dispatchRollbarError } from '../../utils/rollbar'

type Props = {
  children: ReactNode
  name: string
}

type State = {
  hasError: boolean
}

export default class RollbarErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const { name } = this.props
    dispatchRollbarError(error, {
      componentStack: errorInfo.componentStack,
      react_version: reactVersion,
      boundary: name,
    })
  }

  render(): ReactNode {
    const { hasError } = this.state
    const { children } = this.props
    if (hasError) {
      // Inline styles + a vanilla button so this fallback doesn't depend on
      // styled-components / theme / Redux, any of which might be the thing
      // that just failed to render.
      return (
        <div
          role="alert"
          style={{
            padding: '32px',
            margin: '32px auto',
            maxWidth: '480px',
            textAlign: 'center',
            fontFamily: 'sans-serif',
            color: '#333',
          }}
        >
          <h2 style={{ marginTop: 0 }}>Something went wrong.</h2>
          <p>We&apos;ve been notified. Try reloading the page.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      )
    }
    return children
  }
}
